import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  TollBarApp: {
    display: 'flex',
    justifyContent: 'space-between',
    height: '100%',
  },
  FixedStyles: {
    position: 'fixed',
    zIndex: '99999',
  },
  BoxNotifications: {
    display: 'flex',
    padding: '10px',
    alignItems: 'flex-start',
    gap: '8px',
    borderRadius: '6px',
    background: 'var(--Base-White, #FFF)',
    cursor: 'pointer',
    border: '1px solid var(--Gray-300, #D0D5DD)',
    boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
    boxSizing: 'border-box',
  },
  HeaderStyles: {
    display: 'flex',
    gap: '16px',
    alignItems: 'center',
  },
  MenuSettingsContainer: {
    display: 'flex',
    gap: '32px',
    alignItems: 'center',
  },
  MenuSwitch: {
    display: 'flex',
    flexDirection: 'row-reverse',
    gap: '8px',
    alignItems: 'center',
    '& .MuiTypography-root': {
      whiteSpace: 'pre-line',
      textAlign: 'left',
      maxWidth: '80px',
      wordWrap: 'break-word',
      overflowWrap: 'break-word',
      hyphens: 'auto',
    },
  },
  BoxSettings: {
    display: 'flex',
    padding: '8px 16px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px',
    borderRadius: '8px',
    border: '1px solid var(--Gray-300, #D0D5DD)',
    background: 'var(--Base-White, #FFF)',
    boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
    boxSizing: 'border-box',
  },
  BoxPrint: {
    height: '100%',
  },
  LocationText: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '4px',
  },
  ButtonLocation: {
    width: '20px',
    height: '20px',
    cursor: 'pointer',
  },
}));

const buttonPrintStyle = {
  display: 'flex',
  padding: '8px 12px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px',
  height: '100%',
  borderRadius: '8px',
  textTransform: 'none',
  border: '1px solid var(--Gray-300, #D0D5DD)',
  background: 'var(--Base-White, #FFF)',
  boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
  '&:hover': { backgroundColor: 'var(--Base-White, #FFF)' },
  '& > span': {
    margin: 0,
  },
};

export { buttonPrintStyle, useStyles };

